module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"general-analysis":"Genel","scope-1":"scope1","scope-2":"scope2","scope-3":"scope3","compare":"Karşılaştırma"},"en":{"general-analysis":"General","scope-1":"scope1","scope-2":"scope2","scope-3":"scope3","compare":"Compare"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=2!./src/views/Analysis/AnalyzeMain.vue
// module id = G/F+
// module chunks = 1